import { Button } from '@mui/material'
import { useState } from 'react'
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

export const JsonViewer = (props: {
  data?: unknown
  children?: unknown
  collapse?: number
}) => {
  const [collapse, setCollapsed] = useState<number | undefined>(
    props.collapse ?? 1,
  )
  if (!props.data && !props.children) {
    return null
  }

  return (
    <div
      style={{
        backgroundColor: '#011627',
      }}
    >
      <div
        style={{
          textAlign: 'right',
        }}
      >
        <Button onClick={() => setCollapsed(1)}>collapse</Button>
        <Button onClick={() => setCollapsed(collapse + 1)}>expand</Button>
      </div>
      <JsonView
        src={props.data || props.children}
        theme={'a11y'}
        collapsed={collapse}
      />
    </div>
  )
}
